import { render, staticRenderFns } from "./StandardPeaksComponent.vue?vue&type=template&id=e6f9be18&scoped=true&"
import script from "./StandardPeaksComponent.vue?vue&type=script&lang=js&"
export * from "./StandardPeaksComponent.vue?vue&type=script&lang=js&"
import style0 from "./StandardPeaksComponent.vue?vue&type=style&index=0&id=e6f9be18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f9be18",
  null
  
)

export default component.exports